<template>
    <b-overlay :show="loading">
        <b-card
        >
          <b-row>
            <b-col cols="12" class="mb-1">
              <h5 class="mb-25">Stok Retur Konsumen</h5>
              <p class="text-body mb-0">
                Daftar barang retur konsumen yang masuk ke stok mobil.
              </p>
            </b-col>
            <b-col md="3" sm="6" class="my-1">
              <b-form-group label="Per halaman" label-for="perPageSelectRetur" class="mb-0">
                <b-form-select
                  id="perPageSelectRetur"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="5" sm="6" class="my-1">
              <b-form-group label="Cari" label-for="filterInputRetur" class="mb-0">
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInputRetur"
                    v-model="filter"
                    type="search"
                    placeholder="Cari nota / barang..."
                  />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
      
            <b-col cols="12">
                <b-table
                    striped
                    small
                    hover
                    responsive
                    :per-page="perPage"
                    :current-page="currentPage"
                    :items="returs"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :filter="tableFilter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    
                >
                    <template #cell(no)="{index}">
                        {{ ++index }}
                    </template>
                    <template #cell(no_kwitansi)="{item}">
                        <span v-if="item.no_kwitansi">{{ item.no_kwitansi }}</span>
                        <i class="text-danger" v-else>Data Penjualan tidak ditemukan</i>
                    </template>
                    <template #cell(barang)="{item}">
                        <span v-if="item.barang">{{ item.barang }}</span>
                        <i class="text-danger" v-else>Barang tidak ditemukan</i>
                    </template>
                    <template #cell(tanggal)="{item}">
                        {{ humanDate(item.tanggal) }}
                    </template>
                    <template #cell(satuan)="{item}">
                        <span v-if="item.satuan">{{ item.satuan }}</span>
                        <i class="text-danger" v-else>Satuan tidak ditemukan</i>
                    </template>
                </b-table>
            </b-col>
      
            <b-col cols="12" class="d-flex justify-content-between align-items-center mt-1">
              <small class="text-muted">Total {{ totalRows }} data</small>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                size="sm"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-card>
    </b-overlay>
  </template>
  
  <script>
  import Ripple from 'vue-ripple-directive'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import {
    BTable,
    VBTooltip,
    BDropdown,
    BDropdownItem,
    BAvatar,
    BBadge,
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BOverlay,
    BCard,
    BFormCheckbox,
  } from "bootstrap-vue";
  
  export default {
    components: {
      ToastificationContent,
      VBTooltip,
      BCard,
      BModal,
      BDropdown,
      BDropdownItem,
      BTable,
      BAvatar,
      BBadge,
      BOverlay,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BButton,
      BFormCheckbox ,
    },
    directives: {
      "b-tooltip": VBTooltip,
      Ripple,
    },
    data() {
      return {
        currentItem: {
          id_penjualan: null,
          id_konsumen: null,
          id_sales: null,
          nama_konsumen: null,
          tanggal: null,
          id_gudang_m: null,
          keterangan: null,
          rincian: []
        },
        checkedReturs: [],
        allChecked: false,
        id:null,
        blok_id:[],
        gudang_id :[],
        palet_id:[],
        perPage: 10,
        pageOptions: [10, 30, 50, 100],
        totalRows: 1,
        currentPage: 1,
        sortBy: "",
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        filterOn: [],
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        fields: [
            {
                key: 'no',
                label: 'No'
            },
            { key: "no_kwitansi", label: "Nota Penjualan", sortable: true },
            { key: "barang", label: "Barang", sortable: true },
            { key: "tanggal", label: "Tanggal Retur", sortable: true },
            { key: "jumlah", label: "Jumlah Retur", sortable: true },
            { key: "satuan", label: "Satuan Barang", sortable: true }
        ],
        returs: [],
        loading: false
      };
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => ({ text: f.label, value: f.key }));
      },
      tableFilter() {
        const value = this.filter;
        if (value === null || value === undefined) return undefined;
        const trimmed = String(value).trim();
        return trimmed || undefined;
      },
    },
    created() {
      // Set the initial number of items
      this.getReturData()
    },
    methods: {
        async getReturData() {
            const params = { order: "desc" };
            const vehicle = this.$store.getters["gudang/findVehicle"](
              this.$route.params.id
            );
            const salesFromVehicle =
              vehicle && vehicle.karyawan ? vehicle.karyawan.id : null;

            if (this.isSales) {
              params.id_sales = this.user.karyawan.id;
            } else {
              params.id_sales =
                this.$store.state.kendaraan.currentSalesId || salesFromVehicle;
            }

            if (!this.isSales && this.myGudang) {
              params.gudang_id = this.myGudang.id;
            }

            this.loading = true;
            try {
              let returs = await this.$store.dispatch(
                "retur-konsumen/getData",
                params
              );
              if (!Array.isArray(returs)) {
                returs = this.$store.state["retur-konsumen"].datas || [];
              }

              const returBarangs = [];
              returs.forEach((retur) => {
                const rincian = Array.isArray(retur.rincian) ? retur.rincian : [];
                rincian.forEach((row) => {
                  returBarangs.push({
                    no_kwitansi: retur.penjualan
                      ? retur.penjualan.no_kwitansi
                      : null,
                    barang: row.barang ? row.barang.nama : null,
                    tanggal: retur.tanggal,
                    jumlah: row.qty,
                    satuan:
                      row.barang && row.barang.satuan
                        ? row.barang.satuan.satuan
                        : null,
                  });
                });
              });

              this.returs = returBarangs;
              this.totalRows = returBarangs.length;
            } catch (e) {
              this.displayError(e);
              this.returs = [];
              this.totalRows = 0;
            } finally {
              this.loading = false;
            }
        },
      add() {
        this.id = null
        this.currentItem = {
          id_penjualan: null,
          id_konsumen: null,
          id_sales: null,
          nama_konsumen: null,
          tanggal: this.getCurrentDate(),
          id_gudang_m: null,
          keterangan: null,
          rincian: []
        }
        this.$bvModal.show('retur-konsumen-modal')
      },
      edit(item) {
        this.id = item.id
        const currentItem = Object.assign({}, item)
        currentItem.nama_konsumen = currentItem.konsumen ? currentItem.konsumen.nama_toko : ''
        currentItem.id_penjualan = {
          value: currentItem.penjualan.id,
          text: `${currentItem.penjualan.no_kwitansi} - ${currentItem.konsumen ? currentItem.konsumen.nama_toko : ''}`,
          nama_konsumen: currentItem.konsumen ? currentItem.konsumen.nama_toko : '-',
          id_konsumen: currentItem.konsumen  ? currentItem.konsumen.id : null,
          rincian: []
        }
        currentItem.id_konsumen = currentItem.konsumen.id
        currentItem.id_sales = currentItem.sales.id
        currentItem.id_gudang_m = currentItem.sales.id
        this.currentItem = currentItem
        this.$bvModal.show('retur-konsumen-modal')
      },
      remove(item ){
        this.$swal({
          title: 'Anda yakin?',
          text: `Data Retur ini akan dihapus`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya',
          cancelButtonText: 'Batal',
          customClass: {
            confirmButton: 'btn btn-outline-success',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            item.fungsi = 1 // soft delete
            this.$store.dispatch('retur-konsumen/save', [item])
            .then(() => {
              this.getReturData()
              this.displaySuccess({
                message: 'Berhasil'
              })
            })
            .catch(e => {
              this.displayError(e)
              return false
            })
          }
        })
      },
      resetForm() {
        this.id = null
        delete this.form.id
        this.form.palet_id = null
        this.form.blok_id = null
        this.form.gudang_id = null
        this.form.rak = null
      },
      async submit(payload) {
        if(this.id) {
            payload.id = this.id
        }

        try {
            this.loading = true
            // create retur
            const retur = await this.$store.dispatch('retur-konsumen/save', [payload])

            // create retur barang if rincian baran penjualan exist
            if(payload.rincian.length > 0) {
                const payloadsRincian = []
                payload.rincian.map(rincian => {
                    if(rincian.barang) {
                        payloadsRincian.push({
                            id_retur_konsumen: retur.id,
                            id_barang: rincian.barang.id,
                            qty: rincian.qty,
                            harga_jual: rincian.harga_jual
                        })
                    }
                })
                await this.$store.dispatch('retur-konsumen-rincian/save', payloadsRincian)
            }
            this.loading = false

            this.displaySuccess({
                message: 'Retur Konsumen berhasil ditambahkan'
            })

            // if edit action just reload data
            this.$bvModal.hide('retur-konsumen-modal')
            await this.getReturData()
            this.id = null
            setTimeout(() => {
                this.$router.push(`/retur-konsumen/detail/${retur.id}`)
            }, 1000)
        }
        catch(e) {
            this.loading = false
            this.displayError(e)
            return false
        }
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      }
    },
  };
  </script>
  